const _menuObject = {
  ownVessel: {
    menuTitle: "自社船",
    component: "own-vessel",
  },
  selectedVessel: {
    menuTitle: "選択船",
    component: "selected-vessel",
  },
  equipmentBaseStation: {
    menuTitle: "資機材運搬管理",
    component: "equipment-base-station",
  },
  plot: {
    menuTitle: "プロット",
    component: "plot",
  },
  privatePlot: {
    menuTitle: "プライベートプロット",
    component: "private-plot",
  },
  filterMap: {
    menuTitle: "フィルター",
    component: "filter-map",
  },
  settings: {
    menuTitle: "設定",
    component: "settings",
  },
  anchorVessel: {
    menuTitle: "作業船位置",
    component: "anchor-vessel",
  },
};

export default {
  data() {
    return {
      menuObject: _menuObject,
    };
  },
  methods: {},
};
